import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { shiftExtendedSchema } from '../types';

export const getShiftQuery = createAuthQuery({
	request: {
		method: 'GET',
		url: '/shift',
	},
	response: {
		contract: zodContract(shiftExtendedSchema.nullable()),
	},
});
